var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"App"},[_c('v-main',{staticClass:"vertical-center",staticStyle:{"background":"rgba(26, 23, 77, 0.8)"}},[_c('div',{staticClass:"inner-block"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }